<template>
  <div id="foot">
    <p class="icons">
      <a href="https://github.com/Tinku10" target=_blank style="text-decoration: none; color: inherit;"><div id="logo"></div></a>
      <a href="https://medium.com/@tinku.kvs" target=_blank style="text-decoration: none; color: inherit;"><div id="medium"></div></a>
    </p>
    <div>❮ ❯  with ❤ by tinku</div>
  </div>
</template>

<script>
export default {
  components: {}
};
</script>

<style scoped>
div {
  display: block;
  text-align: center;
  margin: none;
  margin-left: -10px;
  margin-right: -10px;
  padding: 5px;
  font-family: "Fira Sans", sans-serif;
  font-weight: lighter;
  color: rgba(255, 251, 251, 0.644);
  background-color: rgb(49, 49, 49);
}
#logo{
  padding: 1px;
  background: url('../../public/github.svg');
  height: 20px;
  width: 20px;
  background-repeat: no-repeat;
  margin-right: 10px;
}
#medium{
  padding: 1px;
  background: url('../../public/medium.svg');
  height: 20px;
  width: 20px;
  background-repeat: no-repeat;
  margin-left: 10px;
}
#foot{
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.icons{
    display:inline-flex;
    flex-direction: row;
    /* justify-content: space-evenly; */
    /* margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px; */

}
</style>
